<!--template html-->
<template>
    <div v-if="collection">
        <div v-if="!isActive" class="gt-groupcard-loader">
            <img :src="$getAssetUrlPlugin('siteres/gt-loader.gif')" alt="Loading" />
            <p>
                Generating card...
            </p>
        </div>
        <!-- Loader -->
       
        <!--<div id="group-card-carousel-parent" :class="{ 'contributor-arrow-blue': isContributor }" :style="['-webkit-transform: scale(' + currentZoomScale + ')', 'transform-origin:' + zoomOrigin]" ref="groupCardPreviewParent">-->
        <div id="group-card-carousel-parent" :class="{ 'contributor-arrow-blue': isContributor }" :style="['-webkit-transform: scale(' + currentZoomScale + ')', 'transform-origin:' + zoomOrigin]" ref="groupCardPreviewParent">
            <div v-if="carouselAutoPlay" id="group-card-view" class="carousel slide" data-interval="3000" data-ride="carousel" data-pause="hover">
                <div class="carousel-inner carousel-iframe">
                    <GroupCardView @activate-carousel="activateCarousel" :collection="collection" :classNamesCover="classNames" :classNamesPages="classNames" :isActive="isActive" :displayPageNames="false" :refreshComponent="refreshComponent" :defaultScale="currentZoomScale" :pageHeight="pageHeight" :messageId="messageId" />
                    <!--GroupCardView component -->
                </div>
                <a class="carousel-control-prev" href="#group-card-view" role="button" data-slide="prev" v-if="!prevGiftSlide" :class="{'show-arrow': nextSlide}">
                    <div class="contributor-arrow-left d-none">
                        <div class="ca-icon">
                            <svg width="15" height="27" viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.0804 1.02583L1.00017 12.945L12.9194 25.0253" stroke="#1E2437" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <!-- contributor-arrow -->
                    <div class="carousel-updated-arrow">
                        <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 2L2 11L11 20" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </a>
                <a class="carousel-control-prev" href="javascript:void(0);" v-if="prevGiftSlide" @click="moveToStage1">
                    <div class="carousel-updated-arrow">
                        <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 2L2 11L11 20" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </a>
                <a class="carousel-control-next" href="#group-card-view" role="button" data-slide="next" v-if="!nextGiftSlide">
                    <div class="contributor-arrow d-none" @click="hideText = true; nextSlide = true">
                        <div class="ca-icon">
                            <svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 25L13 13L1 1" stroke="#1E2437" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="ca-text" :class="{'opacity-0': hideText}">
                            See messages
                        </div>
                    </div>
                    <!-- contributor-arrow -->
                    <div class="carousel-updated-arrow">
                        <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 20L11 11L2 2" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <div class="circle" style="animation-delay: 0s"></div>
                        <div class="circle" style="animation-delay: 1s"></div>
                        <div class="circle" style="animation-delay: 2s"></div>
                        <div class="circle" style="animation-delay: 3s"></div>
                    </div>
                </a>
                <!-- for desktop -->
                <a class="carousel-control-next btn btn-blue" href="javascript:void(0);" v-if="nextGiftSlide" @click="moveToStage2">
                    Next
                </a>
                <!-- for mobile -->
                <a class="carousel-control-next d-flex d-md-none" href="javascript:void(0);" v-if="nextGiftSlide" @click="moveToStage2">
                    <div class="carousel-updated-arrow">
                        <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 2L2 11L11 20" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </a>
            </div>
            <!-- Group card view -->
            <div v-else id="group-card-view" class="carousel slide" data-interval="false" data-ride="carousel" data-pause="hover">
                <div class="carousel-inner">
                    <GroupCardView @activate-carousel="activateCarousel" :collection="collection" :classNamesCover="classNames" :classNamesPages="classNames" :isActive="isActive" :displayPageNames="false" :refreshComponent="refreshComponent" :defaultScale="currentZoomScale" :pageHeight="pageHeight" :messageId="messageId" />
                    <!--GroupCardView component -->
                </div>
                <a class="carousel-control-prev" href="#group-card-view" role="button" data-slide="prev" v-if="!prevGiftSlide" :class="{'show-arrow': nextSlide}">
                    <div class="contributor-arrow-left d-none">
                        <div class="ca-icon">
                            <svg width="15" height="27" viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.0804 1.02583L1.00017 12.945L12.9194 25.0253" stroke="#1E2437" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                    <!-- contributor-arrow -->
                    <div class="carousel-updated-arrow">
                        <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 2L2 11L11 20" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </a>
                <a class="carousel-control-prev" href="javascript:void(0);" v-if="prevGiftSlide" @click="moveToStage1">
                    <div class="carousel-updated-arrow">
                        <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 2L2 11L11 20" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </a>
                <a class="carousel-control-next" href="#group-card-view" role="button" data-slide="next" v-if="!nextGiftSlide">
                    <div class="contributor-arrow d-none" @click="hideText = true; nextSlide = true">
                        <div class="ca-icon">
                            <svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 25L13 13L1 1" stroke="#1E2437" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="ca-text" :class="{'opacity-0': hideText}">
                            See messages
                        </div>
                    </div>
                    <!-- contributor-arrow -->
                    <div class="carousel-updated-arrow">
                        <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 20L11 11L2 2" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <div class="circle" style="animation-delay: 0s"></div>
                        <div class="circle" style="animation-delay: 1s"></div>
                        <div class="circle" style="animation-delay: 2s"></div>
                        <div class="circle" style="animation-delay: 3s"></div>
                    </div>
                </a>
                <!-- for desktop -->
                <a class="carousel-control-next btn btn-blue" href="javascript:void(0);" v-if="nextGiftSlide" @click="moveToStage2">
                    Next
                </a>
                <!-- for mobile -->
                <a class="carousel-control-next d-flex d-md-none" href="javascript:void(0);" v-if="nextGiftSlide" @click="moveToStage2">
                    <div class="carousel-updated-arrow">
                        <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 2L2 11L11 20" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                </a>
            </div>
            <!-- Group card view -->
            <!-- Counter -->
            <div v-if="ifIframecc">
                <div class="carousel-counter">
                    <span class="current-slide">1</span> of <span class="total-slides">3</span>
                </div>

                <div class="carousel-footer text-center mt-4">
                    <svg width="147" height="21" viewBox="0 0 147 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.65708 20.9998C8.71126 20.9998 11.1947 18.4945 11.1947 15.4622V4.25746H8.99753V5.4217C8.99753 5.4217 7.74486 4.10247 5.6352 4.10247C2.51538 4.10247 0.120361 6.58502 0.120361 9.70575C0.120361 12.8256 2.51538 15.2862 5.63611 15.2862C7.74486 15.2862 8.99753 13.9679 8.99753 13.9679V15.4631C8.99958 15.9023 8.91457 16.3376 8.74742 16.7437C8.58026 17.1499 8.33427 17.5189 8.02366 17.8294C7.71304 18.1399 7.34397 18.3858 6.93777 18.5529C6.53157 18.7199 6.09629 18.8048 5.65708 18.8026C4.75633 18.8026 3.89933 18.4726 3.28485 17.8353L1.74591 19.3734C2.77886 20.4282 4.16373 20.9998 5.65708 20.9998ZM5.6352 13.089C3.78993 13.089 2.31754 11.53 2.31754 9.70575C2.31754 7.85957 3.78993 6.29966 5.63611 6.29966C7.48138 6.29966 9.0185 7.85957 9.0185 9.70575C9.0185 11.5291 7.48138 13.089 5.63611 13.089H5.6352ZM13.7283 15.1331H15.9255V9.02471C15.9911 7.48668 17.1772 6.18934 18.6934 6.18934C19.265 6.18934 19.8148 6.38718 20.2761 6.69533L21.1103 4.58567C20.4236 4.26132 19.6725 4.09615 18.9131 4.10247C16.87 4.10247 15.9255 5.55207 15.9255 5.55207V4.25746H13.7283V15.134V15.1331ZM26.8458 15.2862C29.9218 15.2862 32.3615 12.8256 32.3615 9.70575C32.3615 6.56314 29.9218 4.10247 26.8458 4.10247C23.7697 4.10247 21.33 6.56405 21.33 9.70575C21.33 12.8256 23.7697 15.2862 26.8458 15.2862ZM26.8458 13.089C25.0005 13.089 23.5272 11.4416 23.5272 9.70575C23.5272 7.85957 25.0661 6.29966 26.8458 6.29966C28.6254 6.29966 30.1643 7.85957 30.1643 9.70575C30.1643 11.5291 28.6035 13.089 26.8458 13.089ZM39.3934 15.2862C42.4704 15.2862 44.4478 13.2869 44.4478 10.2108V4.25655H42.2507V10.3868C42.2507 12.1445 41.1512 13.265 39.3934 13.265C37.6357 13.265 36.5371 12.1436 36.5371 10.3868V4.25655H34.3399V10.2108C34.3399 13.2869 36.3183 15.2862 39.3934 15.2862ZM46.9769 20.8457H49.1741V13.967C49.1741 13.967 50.4267 15.2853 52.5364 15.2853C55.6125 15.2853 58.0512 12.8247 58.0512 9.68295C58.0512 6.56223 55.6125 4.10156 52.5355 4.10156C50.4267 4.10156 49.1741 5.41987 49.1741 5.41987V4.25655H46.9769V20.8457ZM52.5355 13.089C50.6465 13.089 49.1522 11.5729 49.1522 9.68387C49.1522 7.86048 50.6465 6.29966 52.5364 6.29966C54.4254 6.29966 55.8541 7.85957 55.8541 9.68387C55.8541 11.5729 54.4254 13.089 52.5355 13.089Z" fill="black" />
                        <path d="M20.723 15.9238L20.9847 16.1773C22.5671 17.7047 24.6831 18.5545 26.8824 18.5459C29.0815 18.5543 31.1971 17.7045 32.7793 16.1773L33.0409 15.9238L34.6519 17.4865L34.3738 17.7563C32.3638 19.6968 29.6762 20.7768 26.8824 20.7667C24.0883 20.7771 21.4003 19.6971 19.3901 17.7563L19.1121 17.4865L20.723 15.9238Z" fill="#7FE2DC" />
                        <path d="M62.2918 15.0247H64.489V6.1904H66.4884V4.10262H64.489V0H62.2918V4.10445H60.2925V6.19223H62.2918V15.0247ZM73.2659 15.1569C76.341 15.1569 78.7798 12.6953 78.7798 9.57552C78.7798 6.43291 76.341 3.97225 73.265 3.97225C70.1889 3.97225 67.7492 6.43383 67.7492 9.57552C67.7492 12.6953 70.1889 15.1569 73.265 15.1569H73.2659ZM73.2659 12.9597C71.4197 12.9597 69.9473 11.3114 69.9473 9.57552C69.9473 7.72934 71.4854 6.16944 73.2659 6.16944C75.0446 6.16944 76.5826 7.72934 76.5826 9.57552C76.5826 11.3989 75.0236 12.9588 73.265 12.9588L73.2659 12.9597ZM85.9667 20.8687C89.0209 20.8687 91.5034 18.3643 91.5034 15.332V4.12633H89.3062V5.29056C89.3062 5.29056 88.0545 3.97225 85.9448 3.97225C82.825 3.97225 80.4291 6.45571 80.4291 9.57552C80.4291 12.6953 82.825 15.1569 85.9448 15.1569C88.0545 15.1569 89.3062 13.8377 89.3062 13.8377V15.3329C89.3083 15.772 89.2233 16.2072 89.0562 16.6133C88.8891 17.0194 88.6432 17.3883 88.3327 17.6989C88.0222 18.0094 87.6532 18.2553 87.2471 18.4224C86.841 18.5895 86.4058 18.6745 85.9667 18.6724C85.066 18.6724 84.209 18.3424 83.5936 17.706L82.0555 19.2431C83.0885 20.298 84.4724 20.8696 85.9667 20.8696V20.8687ZM85.9448 12.9588C84.0986 12.9588 82.6263 11.3998 82.6263 9.57552C82.6263 7.72934 84.0986 6.16944 85.9448 6.16944C87.7901 6.16944 89.329 7.72934 89.329 9.57552C89.329 11.3989 87.7901 12.9588 85.9448 12.9588ZM99.0377 15.1569C99.7702 15.1595 100.496 15.0149 101.171 14.7317C101.847 14.4486 102.459 14.0326 102.971 13.5086L101.366 11.9487C100.729 12.6078 99.9165 12.9588 99.0377 12.9588C97.5653 12.9588 96.247 11.9705 95.8951 10.4982H104.343C104.343 6.34539 102.114 3.97225 99.0377 3.97225C95.9616 3.97225 93.5438 6.43383 93.5438 9.57552C93.5438 12.6953 95.9616 15.1569 99.0377 15.1569ZM95.8951 8.41038C96.3564 7.09298 97.4331 6.16944 98.9711 6.16944C100.509 6.16944 101.696 7.15862 102.025 8.41129H95.8951V8.41038ZM107.663 15.0247H109.86V6.1904H111.86V4.10262H109.86V0H107.663V4.10445H105.664V6.19223H107.663V15.0247ZM113.724 15.0028H115.921V9.29016C115.921 7.5543 117.481 6.12659 119.217 6.12659C121.063 6.12659 122.403 7.5543 122.403 9.39957V15.0028H124.601V9.50897C124.601 6.432 122.447 3.97134 119.371 3.97134C117.02 3.97134 115.921 5.42093 115.921 5.42093V0H113.724V15.0028ZM131.967 15.1569C132.7 15.1595 133.425 15.0149 134.101 14.7318C134.777 14.4486 135.388 14.0327 135.9 13.5086L134.297 11.9487C133.659 12.6078 132.846 12.9588 131.967 12.9588C130.495 12.9588 129.176 11.9705 128.825 10.4982H137.46C137.46 6.34539 135.043 3.97225 131.967 3.97225C128.891 3.97225 126.474 6.43383 126.474 9.57552C126.474 12.6953 128.891 15.1569 131.967 15.1569ZM128.825 8.41038C129.287 7.09298 130.363 6.16944 131.902 6.16944C133.44 6.16944 134.626 7.15862 134.956 8.41129H128.825V8.41038ZM139.44 15.0028H141.637V8.89449C141.704 7.35646 142.89 6.05912 144.406 6.05912C144.978 6.05912 145.527 6.25787 145.988 6.56511L146.823 4.45545C146.137 4.13107 145.385 3.9659 144.626 3.97225C142.583 3.97225 141.637 5.42185 141.637 5.42185V4.12724H139.44V15.0038V15.0028Z" fill="black" />
                    </svg>
                </div>
            </div>

        </div>
        <!-- Group card carousel parent -->

        <div v-if="displayScaleBar" class="card-scale-actions d-flex justify-content-end align-items-center">
            <div class="slideCount"></div>
            <div class="zoom-btns">
                <ul class="list-unstyled mb-0">
                    <li>
                        <a href="javascript:void(0);" @click="zoomIn()">
                            <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M22.8027 22.4021L15.8867 15.4861" stroke="white" stroke-width="0.660714" stroke-miterlimit="10" stroke-linecap="round" />
                                <path d="M9.72132 18.041C14.538 18.041 18.4426 14.1363 18.4426 9.31965C18.4426 4.503 14.538 0.598328 9.72132 0.598328C4.90467 0.598328 1 4.503 1 9.31965C1 14.1363 4.90467 18.041 9.72132 18.041Z" stroke="white" stroke-width="0.660714" stroke-miterlimit="10" stroke-linecap="square" />
                                <path d="M9.58984 5.22333V9.18761H13.5541" stroke="white" stroke-width="0.660714" stroke-linecap="round" />
                                <path d="M9.58984 13.1519L9.58984 9.18763L5.62556 9.18763" stroke="white" stroke-width="0.660714" stroke-linecap="round" />
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a href="javascript:void(0);" @click="zoomOut()">
                            <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M23 22.4021L16.084 15.4861" stroke="white" stroke-width="0.660714" stroke-miterlimit="10" stroke-linecap="round" />
                                <path d="M9.91858 18.041C14.7352 18.041 18.6399 14.1363 18.6399 9.31965C18.6399 4.503 14.7352 0.598328 9.91858 0.598328C5.10193 0.598328 1.19727 4.503 1.19727 9.31965C1.19727 14.1363 5.10193 18.041 9.91858 18.041Z" stroke="white" stroke-width="0.660714" stroke-miterlimit="10" stroke-linecap="square" />
                                <line x1="6.15262" y1="9.51797" x2="14.0812" y2="9.51797" stroke="white" stroke-width="0.660714" stroke-linecap="round" />
                            </svg>
                        </a>
                    </li>
                </ul>
            </div>
            <!-- zoom icons -->

            <div class="zoom-dropdown">
                <select @change="onZoomChange($event)">
                    <option value="1">100%</option>
                    <option value="0.5">50%</option>
                    <option value="0.25">25%</option>
                </select>
            </div>
            <!--zoom dropdown -->

            <div class="zoom-full-screen" data-dismiss="modal" aria-label="Close">
                <a href="#">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M1.75 28H7C7.525 28 7.875 27.825 8.225 27.475L27.475 8.225C28.175 7.525 28.175 6.475 27.475 5.775L22.225 0.525C21.525 -0.175 20.475 -0.175 19.775 0.525L0.525 19.775C0.175 20.125 0 20.475 0 21V26.25C0 27.3 0.7 28 1.75 28ZM3.5 21.7L21 4.2L23.8 7L6.3 24.5H3.5V21.7Z" fill="#1E2437" />
                    </svg>
                </a>
            </div>
            <!--resize -->
        </div>
        <!-- Scale options -->
    </div>
</template>
<!--template html-->
<!--script -->
<script>
    import GroupCardView from './GroupCardView.vue'

    export default {
        name: 'GroupCardCarousel',
        components: {
            GroupCardView
        },
        props: {
            collection: String,
            displayScaleBar: Boolean,
            refreshComponent: Number,
            isGift: Boolean,
            isContributor: Boolean,
            triggerScale: Number,
            messageId: String
        },
        data: function () {
            return {
                classNames: [],
                isActive: false,
                currentZoomScale: 1,
                zoomOrigin: "top center",
                zoomMax: 2,
                zoomMin: 0.25,
                zoomInterval: 0.25,
                pageHeight: 765,
                prevGiftSlide: false,
                nextGiftSlide: false,
                nextSlide: false,
                hideText: false,
                carouselAutoPlay: true,
                ifIframecc: false,
                currentIndexes: 0,
            }
        },
        mounted: function () {
            this.checkIframe();
            this.checkIframeCC();
        },
        methods: {
            checkIframe() {
                if ((window.self === window.top) || this.messageId) {
                    this.carouselAutoPlay = false;
                }
            },
            checkIframeCC() {
                if (window.self !== window.top) {
                    this.ifIframecc = true;
                }
            },
            activateCarousel() {
                var messageToFind = this.messageId;
                // Carousel Count
                $('#group-card-view').on('slid.bs.carousel', function () {
                    var currentIndex = $('div.carousel-item.active').index() + 1;
                    $('.current-slide').text(currentIndex);
                });

                var totalSlides = $('.carousel-page').length;
                $('.total-slides').text(totalSlides);
                 

               
                
                

                // Carousel Swipe
                $('.carousel').on('touchstart', function (event) {
                    const xClick = event.originalEvent.touches[0].pageX;
                    $(this).one('touchmove', function (event) {
                        const xMove = event.originalEvent.touches[0].pageX;
                        const sensitivityInPx = 5;

                        if (Math.floor(xClick - xMove) > sensitivityInPx) {
                            $(this).carousel('next');
                        }
                        else if (Math.floor(xClick - xMove) < -sensitivityInPx) {
                            $(this).carousel('prev');
                        }
                    });
                    $(this).on('touchend', function () {
                        $(this).off('touchmove');
                    });
                });

                // 

                var that = this
                $(".carousel-page").addClass("carousel-item")
                if (this.messageId) {
                    // Checking if the card needs to be focused on the message page
                    if (this.messageId) {
                        var specificslide = totalSlides - 1;
                        $('.current-slide').text(specificslide);

                        if (!this.focusOnMessagePage()) {
                            $(".carousel-item:first").addClass("active");
                            
                        }
                    }
                } else {
                    $(".carousel-item:first").addClass("active")
                    if (that.isGift) {
                        $('#group-card-view').on('slid.bs.carousel', function () {
                            that.checkSlide()
                        })
                        //
                        that.checkSlide()
                    }
                }
                this.isActive = true
                this.scaleCard()
                this.$emit('close-popup-on-active')
            },
            onZoomChange(event) {
                this.currentZoomScale = Number(event.target.value)
                this.zoomOrigin = "center"
            },
            zoomIn() {
                if (!(this.currentZoomScale >= 2)) {
                    this.currentZoomScale += this.zoomInterval
                    //change scale origin to avoid going out of bounds
                    if (this.currentZoomScale > 1)
                        this.zoomOrigin = "top"
                }

            },
            zoomOut() {
                if (!(this.currentZoomScale <= 0.25)) {
                    this.currentZoomScale -= this.zoomInterval
                    //change scale origin to avoid going out of bounds
                    if (this.currentZoomScale <= 1)
                        this.zoomOrigin = "center"
                }
            },
            scaleCard() {
                if (this.isActive) {
                    let basePage = {
                        width: 540,
                        height: 765,
                        scale: 1,
                        scaleX: 1,
                        scaleY: 1
                    };
                    let width = this.$refs.groupCardPreviewParent.clientWidth
                    let height = (width / 0.706)
                    var scaleX = 1, scaleY = 1
                    scaleX = width / basePage.width
                    scaleY = height / basePage.height
                    basePage.scaleX = scaleX
                    basePage.scaleY = scaleY
                    basePage.scale = (scaleX > scaleY) ? scaleY : scaleX

                    var newLeftPos = Math.abs(Math.floor(((basePage.width * basePage.scale) - width) / 2))
                    var newTopPos = Math.abs(Math.floor(((basePage.height * basePage.scale) - height) / 2))

                    this.currentZoomScale = basePage.scale
                    this.pageHeight = height
                }
            },
            checkSlide() {
                let totalItems = $('.carousel-item').length
                let currentIndex = $('.carousel-item.active').index() + 1
                this.prevGiftSlide = false
                this.nextGiftSlide = false
                if (currentIndex === 1) {
                    this.prevGiftSlide = true
                }
                else if (currentIndex === totalItems) {
                    this.nextGiftSlide = true
                }
            },
            moveToStage1() {
                this.$emit("prev-stage")
            },
            moveToStage2() {
                this.$emit("next-stage")
            },
            focusOnMessagePage() {
                var messageToFind = this.messageId;
                var pageFound = false;
                $(".page_template_1").each(function (index) {
                    $(this).find(".gc-column-content").each(function () {
                        if ($(this).attr('data-message') === messageToFind) {
                            pageFound = true;
                            return false;
                        }
                    });
                    if (pageFound) {
                        $(this).addClass("active");
                        return false;
                    }
                });
                return pageFound;
            }
        },
        watch: {
            triggerScale: function (newVal, oldVal) {
                this.scaleCard()
            }
        }
    }
</script>
<!--script -->
<!--Add "scoped" attribute to limit CSS to this component only-->
<style scoped>
    a.carousel-control-next.btn.btn-blue {
        height: 50px;
        width: 125px;
        right: -150px;
        top: 50%;
        color: #212529;
        transform: translateY(-50%);
        border-radius: 30px;
    }
</style>
